import React, { useContext } from 'react'
import { Context } from '../'

import { Button, HeaderFirstAction as FirstAction, Header, Icon } from '~ui'

export default function SplitViewSidebarHeader({ children, ...etc }) {
    const context = useContext(Context)

    return (
        <Header
            {...etc}
            data-no-shadow
            data-window-inset>
            <FirstAction className='svSidebarCloseButton'>
                <Button variant='ghost' onClick={context.sidebar.toggle}>
                    <Icon name='close' />
                </Button>
            </FirstAction>

            {children}
        </Header>
    )
}
